import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import moment from 'moment';
export default class PriorityList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      drivers: props.driversAll || [],
      isLoading: true,
      hasError:''
    };
    Echo.
      channel('drivers-priority-list').
      listen('DriverPriorityListUpdate', (e) => {
        //this.getDriversPriorityListData();
      });
  }

  getDriversPriorityListData() {
    let url = "/api/v1/portal/sidebars/drivers-priority-list";
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).
      then((responseText) => {
        let driversJson = responseText.json();
        driversJson.then((drivers) => {
          this.setState({
            drivers: drivers,
            isLoading: false
          })
        }).catch(()=>{
          this.setState({
            isLoading: false,
            hasError:'Nothing found..'
          });
        });
      }).catch(()=>{
        this.setState({
          isLoading: false,
          hasError:'Nothing found..'
        });
      });
  }

  componentDidMount() {
    this.getDriversPriorityListData();
  }

  render() {
    let Drivers = [];
    if (this.state.drivers.length > 0) {
      this.state.drivers.forEach(function (i) {
        Drivers.push(
          <Driver
            key={"driver-priority-list-driver" +
              i.driver_details.driver.user_id
            }
            data={i}
          />
        );
      });
    }

    return (
      <div>
        <div className="col-md-12"><h4>Driver Priority List</h4></div>
        <br/>
        <div className="col-md-12">{(this.state.hasError != '') ? this.state.hasError : ""}</div>
        <ul className="drivers-in-order-of-last-dropoff-list full-width">
          {this.state.isLoading ? (
            <li>
              <span className="add-loading-text">
                <i className="fa fa-spinner fa-pulse"></i>
              </span>
            </li>
          ) :
            Drivers
          }
        </ul>
      </div>
    );
  }
}

class Driver extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      extraDetailsToggled: false,
      play: false,
    };

    this.toggleExtraDetails = this.toggleExtraDetails.bind(this);
  }

  renderJobButton() {
    let jobButton;
    if (this.props.data.driver_details.last_job === null) {
      jobButton = <a href="/jobs/unsent-jobs">
        <button className="btn btn-light btn-sm">
          <i className="fa fa-arrow-left"></i>&nbsp;&nbsp; see jobs not sent to drivers</button>
      </a>
    }
    else {
      jobButton = <a href={"/jobs/view/" + this.props.data.driver_details.last_job.id}>
        <button className="btn btn-dark btn-sm">
          <i className="fa fa-arrow-left"></i>&nbsp;&nbsp;  view job details</button>
      </a>
    }
    return jobButton;
  }

  renderExtraDetails() {
    let lastDropoffBlock;
    let lastDropoffTime = '';

    if (this.props.data.driver_details.last_job === null) {
      lastDropoffTime = <span><i className="fa fa-exclamation"></i> NO JOBS SENT</span>;
    }
    else {
      lastDropoffTime = <span>{this.props.data.job_day_from_now}</span>;
    }

    if (this.props.data.driver_details.last_job === null) {
      lastDropoffBlock = <div>

        <p className={
          "g4-logistics-planning-priority priority-colour-" +
          this.props.data.priority_colour_id}>{lastDropoffTime}</p>

      </div>
    }
    else {
      let pickupTime = ['?','anytime','am','asap','pm'];
      let sTime ='';
      if(pickupTime.indexOf(this.props.data.driver_details.last_job.scheduled_dropoff_time) == -1){
        let momentObj = moment(this.props.data.driver_details.last_job.scheduled_dropoff_time, ["h:mm A"]);
        sTime = momentObj.format("hh:mm A");
      }else{
        sTime = this.props.data.driver_details.last_job.scheduled_dropoff_time;
      }
      lastDropoffBlock = <div>
        <p> has a last dropoff time of</p>
        <p className={
          "g4-logistics-planning-priority priority-colour-" +
          this.props.data.priority_colour_id}>{lastDropoffTime}</p>
        <p> (
          {this.props.data.driver_details.last_job.scheduled_dropoff_preposition}&nbsp;
          {this.props.data.driver_details.last_job.scheduled_dropoff_day}/
          {this.props.data.driver_details.last_job.scheduled_dropoff_month}/
          {this.props.data.driver_details.last_job.scheduled_dropoff_year} @&nbsp;
          {sTime})</p>
        <p> in {this.props.data.driver_details.last_job.dropoff_address ? this.props.data.driver_details.last_job.dropoff_address.town_city : 'N/A'},&nbsp;
        {this.props.data.driver_details.last_job.dropoff_address ? this.props.data.driver_details.last_job.dropoff_address.postcode : 'N/A'}.</p>
      </div>
    }

    return lastDropoffBlock;
  }

  toggleExtraDetails(jobId) {
    document.querySelector('#driver-priority-list-item-page-' +jobId +' .driver-priority-list-extra-details-container').classList.toggle('hidden');
    this.setState({
      extraDetailsToggled: !this.state.extraDetailsToggled
    });
  }

  componentDidMount() {
    this.setState({
      play: true
    });
  }

  render() {
    return (
      <li id={"driver-priority-list-item-page-" +this.props.data.driver_details.driver.user_id}>
        <Animate
          play={this.state.play}
          start={{ opacity: 0 }}
          end={{ opacity: 1 }}
          key={'sidebar-driver-' + this.props.data.id}
        >
          <div className="profile-container">
            <div className="first">
              <img
                src={
                  "/user-images/" +
                  this.props.data.driver_details.driver.user_id
                }
                height="50"
                width="50"
              />
            </div>
            <div className="second">
              <a
                href={
                  "/drivers/view/" +
                  this.props.data.driver_details.id
                }
              >
                {this.props.data.driver_details.full_name}
              </a>
            </div>

            <div className="third">
              <div className="third-first">
                <i
                  className={
                    "fa fa-circle" + (
                      this.props.data.priority_colour_id === 1
                        ? ' red ' : '')
                  }></i>&nbsp;
                <i className={
                  "fa fa-circle" + (
                    this.props.data.priority_colour_id === 2
                      ? ' orange ' : '')
                }></i>&nbsp;
                <i className={
                  "fa fa-circle" + (
                    this.props.data.priority_colour_id > 2
                      ? ' green ' : '')
                }></i>&nbsp;
              </div>
              <div className="third-second">
                <button
                  className="btn btn-sm btn-dark"
                  onClick={() => {
                    this.toggleExtraDetails(
                      this.props.data.driver_details.driver.user_id
                    )
                  }}
                >
                  {this.state.extraDetailsToggled ? '-' : '+'}
                </button>
              </div>
            </div>
          </div>
          <div className="driver-priority-list-extra-details-container hidden">
            <span className="driver-priority-list-contact-number-container">
              <i className="fa fa-phone"></i>&nbsp;
            <strong>
                {this.props.data.driver_details.driver.contact_number}
              </strong>
            </span>
            {this.renderExtraDetails()}
            <div className="small text-left sidebar-view-job-details">
              {this.renderJobButton()}
            </div>
          </div>
        </Animate>
      </li>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-priority-list'
)) {
  ReactDOM.render(
    <PriorityList />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-priority-list'
    )
  );
}
